import { isClient, existClientValue } from "../utils";
import { Config, Options, WindowWithGMNetwork } from "../types";
import InnerCore from "./core";

export class GMNetwork {
  private declare static _core: InnerCore | null;

  public static getGMNetwork(): InnerCore | null {
    if (GMNetwork._core != null) {
      if (isClient() && !existClientValue("gmnetwork")) {
        (window as WindowWithGMNetwork).gmnetwork = GMNetwork._core;
      }

      return GMNetwork._core;
    }

    return null;
  }

  static init(config: Config, options?: Options): InnerCore {
    const core = GMNetwork.getGMNetwork();
    const key = config.projectId + config.clientKey + config.appId;
    if (!!core && core.key != key) {
      GMNetwork.clean();
    }

    if (!GMNetwork.getGMNetwork()) {
      GMNetwork._core = new InnerCore(config, options);
    }

    return GMNetwork.getGMNetwork()!;
  }

  static clean() {
    GMNetwork._core = null;
    if (isClient()) {
      (window as WindowWithGMNetwork).gmnetwork = null;
    }
  }
}

export default GMNetwork;
